import React from "react";
import { Container, Card } from "react-bootstrap";

const Terms = () => (
  <Container style={{ marginTop: "60px", maxWidth: "850px" }}>
    <Card className="shadow-lg border-0 rounded-4">
      <Card.Body className="p-5">
        <h2 className="fw-bold mb-3 text-center">📜 Terms & Conditions</h2>
        <p className="text-muted text-center mb-4">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <p className="lh-lg">
          By registering as an ambulance company, you agree that the information
          provided is accurate and you consent to be contacted regarding your
          application and service usage. You also agree to comply with local
          regulations and our platform policies.
        </p>

        <h5 className="mt-4 mb-3 fw-semibold">Your Responsibilities</h5>
        <ul className="lh-lg">
          <li>Provide valid company documentation upon request.</li>
          <li>Keep your account credentials secure.</li>
          <li>Use the platform responsibly and lawfully.</li>
          <li>
            Allow us to contact you by email or phone regarding your account.
          </li>
        </ul>

        <p className="mt-4">
          For complete details of our terms and conditions, please contact our{" "}
          <a href="/support" className="text-decoration-none fw-semibold">
            Support Team
          </a>
          .
        </p>
      </Card.Body>
    </Card>
  </Container>
);

export default Terms;
